/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  DeleteInteracEmail: (params: vp.DeleteInteracEmailRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostDeleteInteracEmail: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldDeleteInteracEmail, setShouldDeleteInteracEmail] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.DeleteInteracEmailRequest>({
    Token: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldDeleteInteracEmail) return () => {};

    const PostDeleteInteracEmail = async () => {
      setDataFetchingInfo(true, 'Deleting account', 'fullScreen');
      const res = await api.postDeleteInteracEmail(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldDeleteInteracEmail) void PostDeleteInteracEmail();
    setShouldDeleteInteracEmail(false);
    return () => {
      source.cancel();
    };
  }, [shouldDeleteInteracEmail]);

  return [
    response,
    (_params: vp.DeleteInteracEmailRequest) => {
      setParams(_params);
      setShouldDeleteInteracEmail(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldDeleteInteracEmail(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostDeleteInteracEmail);
